import { Swiper, Navigation, Pagination, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
    });

    let adventures = new Swiper(".adventure__slider", {
        watchOverflow: true,
        navigation: {
            nextEl: ".adventure-button-next",
            prevEl: ".adventure-button-prev",
        },
    });

    let areasSlider = new Swiper(".areas__slider", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".areas__next",
            prevEl: ".areas__prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 1.8,
            },
            1200: {
                slidesPerView: 3.2,
                spaceBetween: 20,
            },
        },
    });
};
